import { render, staticRenderFns } from "./LackOfMovementConfig.vue?vue&type=template&id=5137a423&"
import script from "./LackOfMovementConfig.vue?vue&type=script&lang=ts&"
export * from "./LackOfMovementConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports